export const SDK_VERSION = '2.2.9';
export const BEACON_VERSION = '2';
//# sourceMappingURL=constants.js.map